import React from 'react';
import ReactDOM from 'react-dom';
import NavigationMenu_TopHeader from "../../components/top-header/top-header";
import {MenuComponentProps} from "../const";
import VScroll from "../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll";
import {QuickAddItemType} from "../../../../app/quick-add/@types";
import {BUS_TREE_CHANGE} from "../../../../core/gd/bus/bus-event-type"
import NavigationMenu_ReportsContent from "./menu-content";

type State = {
    reRender             : boolean
}

export default class MainMenu_Reports extends React.Component<MenuComponentProps, State> {

    private animationDelay  : any
    private animShow        : boolean = false

    constructor(props:MenuComponentProps) {
        super(props);

        this.state = {
            reRender: false
        };
    }

    componentDidMount() {

        gd.bus.subscribe(BUS_TREE_CHANGE, this, this.sessionDataChanged)

        this.animationDelay = _.delay(()=>{
            this.animShow = true
            const dom = ReactDOM.findDOMNode(this);
            gd.utils.Dom.addClass(dom, 'anim-show');
        }, 25);
    }

    componentWillUnmount() {
        clearTimeout(this.animationDelay)
    }

    reRender = ()=> {
        this.setState({
            reRender: true
        });
    }

    onAddUserClick = (e:React.SyntheticEvent) => {
        if (e) e.stopPropagation();
        // this.hidePopover();
        gd.openNew(QuickAddItemType.USER, {
            type            : 'invite-user',
            organizationId  : gd.companyId
        })
    }

    sessionDataChanged = () => {
        this.forceUpdate()
    }


    render() {

        // has to be company user + to access this section
        if (!gd.ac.check.company.isUser(gd.companyId)) {
            return null
        }

        const classes = Classes('main-menu-container menu-people ui5-menu',{
            'animation': gd.layout.shouldAnimateMenu && !this.props.noAnimation,
            'anim-show': this.animShow
        });

        return (
            <div className={classes}>

                <NavigationMenu_TopHeader space={gd.spaces.reports}/>

                <VScroll ref={this.props.refScroll} className="main-menu-scroll" mutationObserverEnabled={true}>
                   <NavigationMenu_ReportsContent {...this.props} />
                </VScroll>
            </div>
        );
    }
}
